import { getCurrentConference } from '../base/conference/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import logger from './logger';
import { SCREEN_OVERLAY, SCREEN_SHOT, } from './actionTypes';
import { ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
/**
 * Implements the middleware of the chat feature.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const { dispatch, getState } = store;
    // console.log("Six15 Middleware action: "+action.type)
    switch (action.type) {
        case ENDPOINT_MESSAGE_RECEIVED: {
            const { data } = action;
            // logger.info("Message received: Saw Json:" + data + " keys:" + Object.keys(data))
            // logger.info("Message received: Got payload:" + data.six15_payload)
            if (typeof APP !== 'undefined') {
                APP.API._sendEvent({
                    name: SCREEN_OVERLAY,
                    event: data
                });
            }
            else {
                logger.info("Message received: Can't send event, no APP");
            }
            break;
        }
        case SCREEN_SHOT:
        case SCREEN_OVERLAY: {
            const { type, six15_payload } = action;
            // logger.info("About to try sendSix15OverlayPayload type:" + type + " six15_paylod:" + six15_payload)
            const state = store.getState();
            const conference = getCurrentConference(state);
            if (conference) {
                const useP2P = conference.isP2PActive();
                conference.sendMessage(action, '', useP2P);
                // logger.info("sendSix15OverlayPayload worked")
            }
            break;
        }
    }
    return next(action);
});
